import React from 'react';
import { Switch as AntSwitch } from "antd";
import {omit} from 'lodash';
import './styles.less';
export default class Switch extends AntSwitch {

    render() {
        const {label, labelLeft, labelRight, className} = this.props;
        const props = omit(this.props, ['label', 'labelLeft', 'labelRight', 'className'])
        return (
            <span>
                {label && (labelLeft || (!labelLeft && !labelRight)) && <span className="mr-2">{label}</span>}
                <AntSwitch {...props} className={`hms-switch ${className || ''}`}>{this.props.children}</AntSwitch>
                {label && labelRight && <span className="ml-2">{label}</span>}
            </span>
        )
    }
}